import { Node } from 'reactflow';
import styled from 'styled-components';

import { RightSideBarContent, RightSideBarHeader } from 'styles/commonStyles';
import useImageNodeViewer from './hooks/useImageNodeViewer';
import NameFormRow from './components/NameFormRow';
import TargetTypeRow from './components/TargetTypeRow';
import PreprocessingRow from './components/PreprocessingRow';
import PreviewImageModal from 'components/modals/PreviewImageModal';

const Container = styled.div``;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  &:not(:first-child) {
    padding-top: 20px;
  }

  &:not(:last-child) {
    padding-bottom: 20px;
    border-bottom: 1px solid ${(props) => props.theme.global.borderColor};
  }
`;

interface ImageNodeViewerProps {
  node: Node;
}

const ImageNodeViewer = ({ node }: ImageNodeViewerProps) => {
  const { previewImage, isLoading, useFormReturn, preprocessingData, nodeDataSave, onPreviewClose, loadPreviewImage } =
    useImageNodeViewer({
      id: node.id,
      blockData: node.data,
    });
  const { watch } = useFormReturn;

  const target = watch('target');

  if (isLoading) return null;

  return (
    <RightSideBarContent>
      <RightSideBarHeader>
        <h1>Image Data</h1>
      </RightSideBarHeader>
      <Container>
        <Section>
          <NameFormRow useFormReturn={useFormReturn} nodeDataSave={nodeDataSave} />
          <TargetTypeRow useFormReturn={useFormReturn} nodeDataSave={nodeDataSave} />
        </Section>
        <PreprocessingRow
          title="학습 입력 이미지 전처리"
          useFormReturn={useFormReturn}
          name="trainInput"
          functions={preprocessingData!.functions}
          loadPreviewImage={loadPreviewImage}
          nodeDataSave={nodeDataSave}
        />
        {target !== 'folder' && (
          <PreprocessingRow
            title="학습 출력 이미지 전처리"
            useFormReturn={useFormReturn}
            name="trainTarget"
            functions={preprocessingData!.functions}
            loadPreviewImage={loadPreviewImage}
            nodeDataSave={nodeDataSave}
          />
        )}
        <PreprocessingRow
          title="평가 입력 이미지 전처리"
          useFormReturn={useFormReturn}
          name="testInput"
          functions={preprocessingData!.functions}
          loadPreviewImage={loadPreviewImage}
          nodeDataSave={nodeDataSave}
        />
      </Container>
      {previewImage && (
        <PreviewImageModal title={previewImage.title} image={previewImage.image} onClose={onPreviewClose} />
      )}
    </RightSideBarContent>
  );
};

export default ImageNodeViewer;
